import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import {
  REDEEM_LS_INFO,
  REDEEM_LS_INFO_MOBILE,
  REDEEM_WOWCHER_INFO,
  REDEEM_WOWCHER_INFO_MOBILE,
} from '../../../config/constants/images';
import {
  HOW_TO_REDEEM_LIVING_SOCIAL,
  HOW_TO_REDEEM_WOWCHER,
  REDEEM_WOWCHER_INFO_ALT,
} from '../../../config/text/text';
import useCheckMobile from '../../../helpers/checkMobile';
import { isWowcherBrand } from '../../../helpers/pages';
import ThemeContext from '../../../providers/ThemeProvider';
import { useRedeemInstructions } from '../../../services/vouchers';
import WowModal from '../../WowModal';
import Spinner from '../../_generic/spinner/Spinner';

export default function RedeemVoucherInfoModal({ voucher, show, onClose }) {
  const instructions = useRedeemInstructions({
    active: show,
    voucher,
  });

  const theme = useContext(ThemeContext);
  const isMobile = useCheckMobile(false);
  const urlRegex = /(https):\/\/www.redeem-with-us.co.uk\/*\d*\/([\w-]+)/;
  const redeemLink =
    instructions?.length > 0 && instructions[0]?.info.match(urlRegex)?.[0];
  const REDEEM_TEXT_1 = '* If you are unable to scan the the QR code, click';
  const REDEEM_TEXT_2 = 'to redeem';
  const REDEEM_TEXT_3 =
    'If you are unable to scan the QR code, check email to redeem.';
  const isWowcher = isWowcherBrand();

  return (
    <>
      {
        <WowModal
          ariaLabelledBy="id-voucher-redeem-modal"
          extraClasses="voucher-redeem-modal"
          setShowModal={onClose}
          showModal={show}
        >
          <h1 className="redeem-modal__title">
            {isWowcher ? HOW_TO_REDEEM_WOWCHER : HOW_TO_REDEEM_LIVING_SOCIAL}
          </h1>
          <img
            alt={REDEEM_WOWCHER_INFO_ALT}
            className="voucher-redeem-modal__img"
            src={
              isWowcher
                ? isMobile
                  ? REDEEM_WOWCHER_INFO_MOBILE
                  : REDEEM_WOWCHER_INFO
                : isMobile
                ? REDEEM_LS_INFO_MOBILE
                : REDEEM_LS_INFO
            }
          />
          {!instructions && (
            <Spinner display="relative" testId="redeem-spinner" />
          )}

          {instructions && redeemLink ? (
            <p className="redeem-modal__text">
              {REDEEM_TEXT_1}{' '}
              <a
                className="redeem-modal__text-link"
                href={redeemLink}
                rel="noreferrer"
                target="_blank"
              >
                here
              </a>{' '}
              {REDEEM_TEXT_2}.
            </p>
          ) : (
            <p className="redeem-modal__text">{REDEEM_TEXT_3} </p>
          )}
        </WowModal>
      }

      <style jsx>{`
        .redeem-modal__title {
          margin-top: -35px;
          margin-bottom: 10px;
          margin-right: 15px;
          text-align: center;
        }
        .redeem-modal__text {
          text-align: center;
          margin-top: ${isWowcher ? '0px' : '40px'};
          margin-bottom: 35px;
        }
        .redeem-modal__text-link {
          text-decoration: underline;
        }
        .voucher-redeem-modal__img {
          display: block;
          max-width: 100%;
          margin-top: 0px;
          margin-bottom: -40px;
        }
        :global(.voucher-redeem-modal .modal-content) {
          border: 2px solid ${theme.colors.primary};
        }
        @media (min-width: ${theme.breakpoints.lgUp}) {
          .redeem-modal__title {
            margin-top: -10px;
            margin-bottom: 10px;
            text-align: center;
          }
          .icon {
            display: block;
          }
          :global(.voucher-redeem-modal .modal-content) {
            border: 2px solid ${theme.colors.primary};
          }
        }
      `}</style>
    </>
  );
}

RedeemVoucherInfoModal.propTypes = {
  onClose: PropTypes.func,
  show: PropTypes.bool,
  voucher: PropTypes.object,
};
